import {createEventHandler} from 'recompose';
import {FormModalHOC, modalOptions} from '../../components/modals/FormModal';
import {buildCreateRequestModal, buildUpdateRequestModal} from '../../config/redux-list/requestModals';
import {getModalSubState} from '../../core-utilities/redux-request-modal/utils';
import {MilestoneForm} from '../../projects/components/MilestoneForm';
import {TaskType} from '../../tasks/enums/TaskType';
import {logger} from './logger';


export function makeEditMilestoneModal(config) {
  const {
    isCreate,
    prefix,
    getState,
    path,
  } = config;

  const buildOnSave = isCreate ? makeOnSave(getState) : void 0;

  const EditMilestoneFormModalComponent = FormModalHOC(MilestoneForm, {
    modalHeaderLabel: isCreate ? 'milestones.create.header.label' : 'milestones.edit.header.label',
  });

  const builderFn = isCreate ? buildCreateRequestModal : buildUpdateRequestModal;

  return builderFn({
    prefix,
    getState,
    path,
    buildOnSave,
    modalOptions: modalOptions,
    modalComponent: EditMilestoneFormModalComponent,
    logger,
  });
}

function makeOnSave(getState) {
  return (state$, dispatch, props$, actions) => {
    const {
      handler: onSave,
      stream: save$,
    } = createEventHandler();

    const modalState$ = state$
      .map(getState)
      .map(getModalSubState)
      .distinctUntilChanged()
      .takeUntil(props$.last());

    save$
      .withLatestFrom(modalState$)
      .takeUntil(props$.last())
      .subscribe(([data, modalState]) => {
        const request = {
          ...data,
          orgId: modalState.orgId,
          projectId: modalState.projectId,
          assetSpecific: modalState.taskType !== TaskType.PROJECT,
        };
        dispatch(actions.sendRequest(request));
      });

    return onSave;
  };
}



// WEBPACK FOOTER //
// ./src/js/milestones/redux/configEditMilestoneRequests.js